// LLM generated - Model Claude 4 Sonnet
import { createStyles } from '@mantine/core';

export const useStyles = createStyles((theme) => ({
  container: {
    width: theme.breakpoints.xs,
    borderRadius: theme.radius.xl, // Override modal border radius

    [theme.fn.smallerThan('sm')]: {
      width: '100%',
      borderRadius: `${theme.radius.xs} ${theme.radius.xs} 0 0`, // Only top corners on mobile drawer
    },
  },
  scrollableContent: {
    maxHeight: '80vh',
    overflowY: 'auto',

    // Prevent layout shift when scrollbar appears
    '@supports (scrollbar-gutter: stable)': {
      scrollbarGutter: 'stable',
    },
    '@supports not (scrollbar-gutter: stable)': {
      paddingRight: theme.other.spacing._2,
    },

    // WebKit scrollbar styling (Chrome, Safari, Edge)
    '&::-webkit-scrollbar': {
      width: theme.other.spacing._8,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'transparent',
      borderRadius: theme.radius.sm,
      transition: 'background-color 0.2s ease',
    },
    '&:hover::-webkit-scrollbar-thumb, &:focus-within::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.2)',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: 'rgba(0, 0, 0, 0.3)',
    },

    // Firefox scrollbar styling
    scrollbarWidth: 'thin',
    scrollbarColor: 'transparent transparent',
    '&:hover': {
      scrollbarColor: 'rgba(0, 0, 0, 0.2) transparent',
    },

    // Mobile adjustments
    [theme.fn.smallerThan('sm')]: {
      maxHeight: '70vh',

      '&::-webkit-scrollbar': {
        width: 6,
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'transparent',
        borderRadius: theme.radius.xs,
        transition: 'background-color 0.2s ease',
      },
      '&:hover::-webkit-scrollbar-thumb, &:focus-within::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.2)',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: 'rgba(0, 0, 0, 0.3)',
      },
    },
  },
  fullWidthButton: {
    width: '100%',
  },
  noFirstParagraphMargin: {
    '& p:first-child': {
      marginTop: 0,
    },
  },
  flexContainer: {
    flex: 1,
  },
}));
